"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerImage = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _head = _interopRequireDefault(require("next/head"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _models = require("../../../../models");
var _constants = require("../../../BannerProductListing/constants");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBannerImage = (param)=>{
    let { size, backgroundImage, link, promoBannerType } = param;
    const { title: linkTitle } = link !== null && link !== void 0 ? link : {};
    const { getTestId } = (0, _testidGenerator.default)();
    const theme = (0, _mui.useTheme)();
    const { isFocusPage } = (0, _contexts.useBannerProductListingContext)();
    const imagesVariants = (0, _react.useMemo)(()=>backgroundImage ? {
            url: backgroundImage,
            backgroundColor: theme.palette.grey[100],
            imageFormat: 'WebP',
            imageSizeMultiplier: 2,
            params: [
                {
                    width: _constants.BANNER_SIZE_IN_PX.Size1,
                    quality: 90
                },
                {
                    width: _constants.BANNER_SIZE_IN_PX.Size2,
                    quality: 90
                },
                {
                    width: 200,
                    quality: 90
                },
                {
                    width: 300,
                    quality: 90
                },
                {
                    width: 400,
                    quality: 90
                },
                {
                    width: 600,
                    quality: 90
                }
            ]
        } : undefined, [
        backgroundImage,
        theme.palette.grey
    ]);
    if (!backgroundImage) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Image, {
                size: size,
                promoBannerType: promoBannerType,
                alt: linkTitle !== null && linkTitle !== void 0 ? linkTitle : '',
                "data-testid": getTestId(_constants2.BANNER_IMAGE),
                fetchPriority: "high",
                sizes: "(max-width: 450px) ".concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 200 : 400, "px,\n                  (max-width: ").concat(theme.breakpoints.values.sm - 1, "px) ").concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 300 : 600, "px, ").concat(_constants.BANNER_SIZE_IN_PX[size], "px"),
                src: backgroundImage,
                srcSet: imagesVariants ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)) : undefined,
                isFocusPage: isFocusPage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_head.default, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: backgroundImage,
                    imageSrcSet: imagesVariants ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)) : undefined,
                    imageSizes: "(max-width: 450px) ".concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 200 : 400, "px,\n                    (max-width: ").concat(theme.breakpoints.values.sm - 1, "px) ").concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 300 : 600, "px, ").concat(_constants.BANNER_SIZE_IN_PX[size], "px")
                })
            })
        ]
    });
};
exports.PromoBannerImage = PromoBannerImage;
